/* eslint-disable */

var MeetingsEmbedCode = window.MeetingsEmbedCode || {};
MeetingsEmbedCode = function (meetingsEmbedCodeModule) {
  const scriptSrc = document.currentScript && document.currentScript.src || '';
  function tryGetLocalStorage(key) {
    try {
      return localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }
  const debugEnabled = scriptSrc.indexOf('debug=true') > -1 || tryGetLocalStorage('MEETINGS_EMBED_DEBUG') === 'true';
  function debugLog(...message) {
    if (debugEnabled) {
      console.debug(...message);
    }
  }
  function elementContainsIframe(element) {
    return element.querySelectorAll('iframe').length > 0;
  }
  meetingsEmbedCodeModule.elementContainsIframe = elementContainsIframe;
  function getParentPageUrl(origin, pathname) {
    if (origin || pathname) {
      return `&parentPageUrl=${origin}${pathname}`;
    }
    return '';
  }
  meetingsEmbedCodeModule.getParentPageUrl = getParentPageUrl;
  function getUtk(name) {
    let cookieValue = null;
    if (document.cookie && document.cookie !== '') {
      const cookies = document.cookie.split(';');
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        const cookieName = `${name}=`;
        if (cookie.substring(0, name.length + 1) === cookieName) {
          cookieValue = cookie.substring(name.length + 1);
          break;
        }
      }
    }
    return cookieValue;
  }
  meetingsEmbedCodeModule.getUtk = getUtk;
  function getQueryParam(name) {
    const search = window.location.search;
    if (!search) return null;
    const params = search.substring(1).split('&');
    for (let i = 0; i < params.length; i++) {
      const pair = params[i].split('=');
      if (decodeURIComponent(pair[0]) === name) {
        return pair.length > 1 ? decodeURIComponent(pair[1]) : '';
      }
    }
    return null;
  }
  meetingsEmbedCodeModule.getQueryParam = getQueryParam;
  function isInCrossOriginFrame() {
    if (window.self === window.top) return false;
    try {
      void window.parent.document;
      return false;
    } catch (e) {
      return true;
    }
  }
  meetingsEmbedCodeModule.isInCrossOriginFrame = isInCrossOriginFrame;
  function getParentUtkParam(utk) {
    if (utk) {
      return `&parentHubspotUtk=${encodeURIComponent(utk)}`;
    }
    return '';
  }
  meetingsEmbedCodeModule.getParentUtkParam = getParentUtkParam;
  function getParentQueryParams(queryParamString) {
    if (queryParamString) {
      return `&${queryParamString.slice(1)}`;
    }
    return '';
  }
  meetingsEmbedCodeModule.getParentQueryParams = getParentQueryParams;
  function buildAbTestingParams(ab, abStatus, contentId) {
    const abParam = ab ? `&ab=${ab}` : '';
    const abStatusParam = abStatus ? `&abStatus=${abStatus}` : '';
    const contentIdParam = contentId ? `&contentId=${contentId}` : '';
    return abParam + abStatusParam + contentIdParam;
  }
  meetingsEmbedCodeModule.buildAbTestingParams = buildAbTestingParams;

  // start of uuid generation functions copied from LiveMessageUI/MessagesWidgetShell/static/js/hsGenerator.js
  function mathRandomUuid() {
    let d = new Date().getTime();
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = (d + Math.random() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
  }
  function cryptoUuid() {
    const cryptoLib = window.crypto || window.msCrypto;
    const buf = new Uint16Array(8);
    cryptoLib.getRandomValues(buf);
    const S4 = function S4(num) {
      let ret = num.toString(16);
      while (ret.length < 4) {
        ret = `0${ret}`;
      }
      return ret;
    };
    return S4(buf[0]) + S4(buf[1]) + S4(buf[2]) + S4(buf[3]) + S4(buf[4]) + S4(buf[5]) + S4(buf[6]) + S4(buf[7]);
  }
  function generateUtk() {
    const cryptoLib = window.crypto || window.msCrypto;
    if (typeof cryptoLib != 'undefined' && typeof cryptoLib.getRandomValues != 'undefined' && typeof window.Uint16Array != 'undefined') {
      return cryptoUuid();
    }
    return mathRandomUuid();
  }
  // end uuid generation functions

  function getOrSetHubspotUtk() {
    const hstcUtk = (getUtk('__hstc') || '').split('.')[1];
    let utk = hstcUtk || window.__hsUserToken;
    debugLog('[MeetingsEmbed] getOrSetHubspotUtk __hstc/window.__hsUserToken:', hstcUtk, window.__hsUserToken);
    if (!utk) {
      const newUtk = generateUtk();
      utk = newUtk;
      window.__hsUserToken = newUtk;
    }
    return utk;
  }
  meetingsEmbedCodeModule.getOrSetHubspotUtk = getOrSetHubspotUtk;

  // Sync-only UTK lookup used at initial iframe injection: __hstc second
  // segment or window.__hsUserToken if present. Returns null without
  // generating a new token — late listeners will supply one.
  function getInitialUtk() {
    const hstcUtk = (getUtk('__hstc') || '').split('.')[1];
    return hstcUtk || window.__hsUserToken || null;
  }
  meetingsEmbedCodeModule.getInitialUtk = getInitialUtk;
  function getIframeOrigin(iframe) {
    try {
      return new URL(iframe.src).origin;
    } catch (e) {
      return null;
    }
  }
  const whitelist = ['https://local.hubspot.com', 'https://local-eu1.hubspot.com', 'https://local.hubspotqa.com', 'https://local-eu1.hubspotqa.com', 'https://app.hubspot.com', 'https://app-eu1.hubspot.com', 'https://app.hubspotqa.com', 'https://app-eu1.hubspotqa.com', 'https://meetings.hubspot.com', 'https://meetings-eu1.hubspot.com', 'https://meetings.hubspotqa.com', 'https://meetings-eu1.hubspotqa.com'];
  function isHubSpotOrigin(origin) {
    return whitelist.indexOf(origin) > -1;
  }
  meetingsEmbedCodeModule.isHubSpotOrigin = isHubSpotOrigin;

  // inbound from meetings iframe: { height: N }
  function resize(e, iframe) {
    if (e.data.height && (isHubSpotOrigin(e.origin) || e.origin === window.origin)) {
      iframe.style.height = `${e.data.height}px`;
    }
  }
  meetingsEmbedCodeModule.resize = resize;
  const _hsp = window._hsp = window._hsp || [];
  const _hsq = window._hsq = window._hsq || [];

  // inbound from meetings iframe: 'readyForConsentListener'
  // outbound to meetings iframe: { type: 'privacy-consent', shouldTrackAnalytics }
  function addPrivacyConsentListener(e, iframe) {
    if (e.data === 'readyForConsentListener' && e.source !== null && e.source === iframe.contentWindow) {
      _hsp.push(['addPrivacyConsentListener', function (consent) {
        const allowed = consent.allowed;
        const currentCategories = consent.categories;
        const shouldTrackAnalytics = allowed || currentCategories.analytics;
        iframe.contentWindow.postMessage({
          type: 'privacy-consent',
          shouldTrackAnalytics
        }, getIframeOrigin(iframe));
      }]);
    }
  }
  meetingsEmbedCodeModule.addPrivacyConsentListener = addPrivacyConsentListener;

  // inbound from parent page: { type: 'HS_CTA_PARENT_RECEIVED_ANALYTICS', payload: { hutk } }
  // outbound to meetings iframe: { type: 'utk-update', utk }
  // TODO: verify exact message type string against web-interactives-container before shipping

  // Intentional: customer page origin is unknown at build time; we trust by source identity (window.parent) instead
  function handleCtaAnalyticsMessage(e, iframe) {
    debugLog(`[MeetingsEmbed] handleCtaAnalyticsMessage - e.data: ${e.data} e.type: ${e.type}`);
    if (!e.data || e.data.type !== 'HS_CTA_PARENT_RECEIVED_ANALYTICS') return;
    if (e.source !== window.parent) return;
    const hutk = e.data.payload && e.data.payload.hutk;
    if (!hutk || !iframe.contentWindow) return;
    const iframeOrigin = getIframeOrigin(iframe);
    if (!iframeOrigin) return;
    iframe.contentWindow.postMessage({
      type: 'utk-update',
      utk: hutk
    }, iframeOrigin);
  }
  meetingsEmbedCodeModule.handleCtaAnalyticsMessage = handleCtaAnalyticsMessage;
  function appendMeetingsIframe(container, pageInfo) {
    var _container$dataset$sr;
    debugLog(`[MeetingsEmbed] appendMeetingsIframe — utk: ${pageInfo.utk} origin: ${pageInfo.origin}`);
    const src = (_container$dataset$sr = container.dataset.src) !== null && _container$dataset$sr !== void 0 ? _container$dataset$sr : '';
    const title = container.dataset.title;
    const iframe = document.createElement('iframe');
    const ab = container.dataset.ab;
    const abStatus = container.dataset.abStatus;
    const contentId = container.dataset.contentId;
    container.style.height = '100%';
    iframe.src = src + meetingsEmbedCodeModule.getParentUtkParam(pageInfo.utk) + meetingsEmbedCodeModule.getParentPageUrl(pageInfo.origin, pageInfo.pathname) + meetingsEmbedCodeModule.getParentQueryParams(pageInfo.queryParams) + meetingsEmbedCodeModule.buildAbTestingParams(ab, abStatus, contentId);
    if (title) {
      iframe.title = title;
    }
    iframe.width = '100%';
    iframe.style.minWidth = '312px';
    iframe.style.minHeight = '615px';
    iframe.style.height = '756px';
    iframe.style.border = 'none';
    iframe.setAttribute('data-hs-ignore', 'true');
    container.appendChild(iframe);
    window.addEventListener('message', function (e) {
      meetingsEmbedCodeModule.resize(e, iframe);
    });
    window.addEventListener('message', function (e) {
      meetingsEmbedCodeModule.addPrivacyConsentListener(e, iframe);
    });
    return iframe;
  }
  function createMeetingsIframe(selector) {
    const containers = document.querySelectorAll(selector);
    const iframes = [];
    debugLog(`[MeetingsEmbed] createMeetingsIframe — selector: ${selector} found: ${containers.length}`);
    for (let i = 0; i < containers.length; i++) {
      const container = containers[i];
      if (elementContainsIframe(container)) {
        debugLog(`[MeetingsEmbed] container ${i} — skipping, iframe already exists`);
        continue;
      }
      if (meetingsEmbedCodeModule.isInCrossOriginFrame()) {
        // CTA scenario: we're in a cross-origin iframe and cannot read
        // the customer page's cookies directly. The CTA passes the
        // visitor's UTK as a query param — the live UTK may also arrive
        // later as a utk-update postMessage handled by the Meetings app.
        const ctaUtk = getQueryParam('utk');
        debugLog(`[MeetingsEmbed] FLOW: cross-origin CTA — utk from query param: ${ctaUtk}`);
        const ctaIframe = appendMeetingsIframe(container, {
          utk: ctaUtk,
          origin: '',
          pathname: '',
          queryParams: window.location.search
        });
        iframes.push(ctaIframe);
        window.addEventListener('message', function (e) {
          meetingsEmbedCodeModule.handleCtaAnalyticsMessage(e, ctaIframe);
        });
      } else {
        // Direct embed: always inject the iframe immediately with whatever
        // UTK is available synchronously (may be null). Any authoritative
        // UTK that arrives later — from the tracking script or from late
        // consent — is pushed into the iframe via a utk-update postMessage.
        const initialUtk = meetingsEmbedCodeModule.getInitialUtk();
        debugLog(`[MeetingsEmbed] FLOW: direct embed — injecting with initial utk: ${initialUtk}`);
        const createdIframe = appendMeetingsIframe(container, {
          utk: initialUtk,
          origin: window.location.origin,
          pathname: window.location.pathname,
          queryParams: window.location.search
        });
        iframes.push(createdIframe);

        // outbound to meetings iframe: { type: 'utk-update', utk }
        function postUtkUpdate(utk) {
          debugLog(`[MeetingsEmbed] postUtkUpdate - utk: ${utk}`);
          if (!utk || !createdIframe.contentWindow) return;
          const iframeOrigin = getIframeOrigin(createdIframe);
          if (!iframeOrigin) return;
          createdIframe.contentWindow.postMessage({
            type: 'utk-update',
            utk
          }, iframeOrigin);
        }
        let pendingUtk = null;
        let analyticsConsented = false;
        _hsq.push(['addUserTokenListener', function (utk) {
          if (analyticsConsented) {
            postUtkUpdate(utk);
          } else {
            pendingUtk = utk;
          }
        }]);
        function handleConsentForUtk(consent) {
          analyticsConsented = !!(consent && consent.categories && consent.categories.analytics);
          if (!analyticsConsented) return;
          postUtkUpdate(pendingUtk || meetingsEmbedCodeModule.getOrSetHubspotUtk());
          pendingUtk = null;
        }
        _hsp.push(['addPrivacyConsentListener', handleConsentForUtk]);
      }
    }
    return iframes;
  }
  meetingsEmbedCodeModule.createMeetingsIframe = createMeetingsIframe;
  createMeetingsIframe('.meetings-iframe-container');
  if (!window.hbspt) {
    window.hbspt = {};
  }
  if (!window.hbspt.meetings) {
    window.hbspt.meetings = {};
  }
  window.hbspt.meetings.create = createMeetingsIframe;
  if (typeof exports === 'object') {
    module.exports = meetingsEmbedCodeModule;
  }
  return meetingsEmbedCodeModule;
}(MeetingsEmbedCode);